@if (formGroup) {
  <form class="row mt-5 pb-5" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="col-12 col-lg-8 col-xl-8 mx-auto">
      <div class="row">
        <div class="col-12">
          <h5 class="text-primary">Modifier l'évènement</h5>
        </div>
        <div class="mb-3 text-secondary col-12">
          <label>Message</label>
          <textarea class="form-control" rows="15" formControlName="textValue"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="d-grid col-12 col-lg-auto col-xl-2 mt-2 ms-auto">
          <button type="submit" class="btn btn-primary">Sauvegarder</button>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-8 mx-auto">
      <h5 class="text-primary">Mode maintenance</h5>
      <div class="d-flex flex-row align-items-center flex-wrap text-secondary">
        <div class="form-check form-switch">
          <input id="maintenance-mode" class="form-check-input" type="checkbox" formControlName="maintenance" />
          <label class="form-check-label" for="maintenance-mode">Actif</label>
        </div>
      </div>
    </div>
  </form>
}
